module.exports = __webpack_public_path__ + "img/share_poster.2145a282.gif";